module.exports = __webpack_public_path__ + "img/mobile.9150bc64.jpeg";